import Vue from 'vue'
import XEUtils from 'xe-utils'

Vue.prototype.$utils = XEUtils
Vue.prototype.$cookie = XEUtils.cookie
